import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Account } from './account';
import { Activity } from './activity';
import { Address } from './address';
import { AdminApi } from './admin';
import { Allocations } from './allocations';
import { Amenities } from './amenities';
import { Buildings } from './buildings';
import { Companies } from './companies';
import { Corrections } from './corrections';
import { Dashboard } from './dashboard';
import { InUnitAmenities } from './inUnitAmenities';
import { Fees } from './fees';
import { FileApi } from './file';
import { Hubspot } from './hubspot';
import { Notifications } from './notifications';
import { Payment } from './payment';
import { Portfolios } from './portfolios';
import { Properties } from './properties';
import { PropertyUtility } from './propertyUtility';
import { Report } from './report';
import { Residencies } from './residencies';
import { Resident } from './resident';
import { Roommates } from './roommates';
import { Statement } from './statement';
import { TeamMembers } from './teamMembers';
import { Transaction } from './transaction';
import { Units } from './units';
import { UtilityProviders } from './utilityProviders';
import { Urjanet } from './urjanet';
import { Tags } from './tags';
import { Credentials } from './credentials';
import { Vendors } from './vendors';
import { AppfolioBills } from './appfolio/bills';
import { AppfolioProperties } from './appfolio/properties';
import { Stripe } from './stripe';
import { BillAutomationBills } from './billAutomation/bills';
import { BillAutomationAllowedSenders } from './billAutomation/allowedSenders';
export class Api {
  constructor() {
    _defineProperty(this, "Account", new Account());
    _defineProperty(this, "Activity", new Activity());
    _defineProperty(this, "Address", new Address());
    _defineProperty(this, "AdminApi", new AdminApi());
    _defineProperty(this, "Allocations", new Allocations());
    _defineProperty(this, "Amenities", new Amenities());
    _defineProperty(this, "Buildings", new Buildings());
    _defineProperty(this, "Companies", new Companies());
    _defineProperty(this, "Corrections", new Corrections());
    _defineProperty(this, "Dashboard", new Dashboard());
    _defineProperty(this, "Fees", new Fees());
    _defineProperty(this, "FileApi", new FileApi());
    _defineProperty(this, "Hubspot", new Hubspot());
    _defineProperty(this, "InUnitAmenities", new InUnitAmenities());
    _defineProperty(this, "Notifications", new Notifications());
    _defineProperty(this, "Payment", new Payment());
    _defineProperty(this, "Portfolios", new Portfolios());
    _defineProperty(this, "Properties", new Properties());
    _defineProperty(this, "PropertyUtility", new PropertyUtility());
    _defineProperty(this, "Report", new Report());
    _defineProperty(this, "Residencies", new Residencies());
    _defineProperty(this, "Resident", new Resident());
    _defineProperty(this, "Roommates", new Roommates());
    _defineProperty(this, "Statement", new Statement());
    _defineProperty(this, "TeamMembers", new TeamMembers());
    _defineProperty(this, "Transaction", new Transaction());
    _defineProperty(this, "Units", new Units());
    _defineProperty(this, "UtilityProviders", new UtilityProviders());
    _defineProperty(this, "Urjanet", new Urjanet());
    _defineProperty(this, "Tags", new Tags());
    _defineProperty(this, "Credentials", new Credentials());
    _defineProperty(this, "Vendors", new Vendors());
    _defineProperty(this, "AppfolioBills", new AppfolioBills());
    _defineProperty(this, "AppfolioProperties", new AppfolioProperties());
    _defineProperty(this, "Stripe", new Stripe());
    _defineProperty(this, "BillAutomationBills", new BillAutomationBills());
    _defineProperty(this, "BillAutomationAllowedSenders", new BillAutomationAllowedSenders());
  }
}
export const api = new Api();